import { render, staticRenderFns } from "./CtaContact.vue?vue&type=template&id=8c6fea42&"
import script from "./CtaContact.vue?vue&type=script&lang=js&"
export * from "./CtaContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports